import { getUrl } from '../utils/getUrl';
import { headers } from './account';

interface GetStoriesType {
  handle: string;
  from?: string;
  to?: string;
}

export const getStories = async ({ handle, from, to }: GetStoriesType) => {
  const fromParam = !from ? '' : `?from_date=${from}`;
  const toParam = !to ? '' : `${from ? '&' : '?'}to_date=${to}`;

  return fetch(
    `${getUrl()}/api/account/${handle}/stories${fromParam}${toParam}`,
    {
      headers,
    }
  ).then((res) => res.json());
};

export const getTodaysStories = (handle: string) => {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  return getStories({
    handle,
    from: (yesterday.getTime() / 1000).toFixed(),
    to: (new Date().getTime() / 1000).toFixed(),
  });
};
